import React from 'react';
import './index.scss';
import classNames from 'classnames';
import { useIntl, connect, history } from 'umi';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import GameImage from '@/pages/home/components/GameImage';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';

export default function SimilarCard(props: any) {
  // 游戏类型默认mobile
  const { gameData = {}, gameType = 'mobileGames', activeId, moduleName, setDetailIndex, entityType } = props;
  const { entity_type: gameEntityType, name, cover, country, publisher, app_id } = gameData;
  const reallyEntityType = gameEntityType || entityType;
  const emblem = (country?.split('|')[0] || 'default').toLowerCase();
  const { resetDetailFilterExtend } = useFilterExtend({});

  // 点击跳转游戏详情
  const gotoSingleGames = (app_id: any) => {
    //清除详情页继承逻辑
    resetDetailFilterExtend();
    setDetailIndex([]);
    history.push(getDetailGamePath(app_id));
  };

  const getDetailGamePath = (gameId: string) => {
    return getDetailGamePathCommon({
      entityType: reallyEntityType,
      gameId: gameId,
      tab: activeId,
      subTab: '',
    });
  };

  return (
    <ARightClickToJump href={getDetailGamePath(app_id)} style={{ display: 'inline' }}>
      <div
        className={`dbi-similargame-card ${`dbi-similargame-card--${reallyEntityType}`}`}
        onClick={() => {
          gotoSingleGames(app_id);
        }}
      >
        {/* <img src={cover}
        className={classNames({
          'dbi-similargame-card-img': reallyEntityType == 'mobile',
          'dbi-similargame-card-imgRow': reallyEntityType == 'pc',
          'dbi-similargame-card-imgDire': reallyEntityType == 'console',
        })}
      /> */}
        <GameImage
          className={classNames({
            'dbi-similargame-card-img': reallyEntityType === 'mobile',
            'dbi-similargame-card-imgRow': reallyEntityType === 'pc',
            'dbi-similargame-card-imgDire': [PC_CONSOLE_COMBINE_ENTITY_TYPE, 'console'].includes(reallyEntityType),
          })}
          key={'SimilarCard'}
          src={cover}
          entityType={reallyEntityType}
        />
        <div className="dbi-similargame-card-info">
          <div className="dbi-similargame-card-title">
            {name}
          </div>
          <div className="dbi-similargame-card-flex">
            <img
              src={getCountryFlag(emblem?.toLocaleUpperCase())}
              className="national-emblem"
            ></img>
            <span className="dbi-similargame-card-text">{publisher}</span>
          </div>
        </div>
      </div>
    </ARightClickToJump>

  );
}
